var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(this.$route.params.txid)?_c('div',[_c('router-view')],1):_c('div',{staticClass:"page-admin show-cards-in-sequence-- show-cards-up--"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row"},[_c('card-component',{staticStyle:{"min-height":"calc(100vh - 300px)"},attrs:{"block":false,"title":"Atendimentos","subtitle":"","col":{ xs: 12 },"select":[
            { id: null, name: 'Últimos cadastros' },
            { id: 'first', name: 'Mais antigos' }
          ],"select2":[
            { id: null, name: 'Etapa da transação' },
            { id: 'CREATED', name: 'Criado' },
            { id: 'STARTED', name: 'Iniciado' },
            { id: 'ANALYSIS', name: 'Em Análise' },
            { id: 'INSTALLMENT_SELECTION', name: 'Seleção de Parcela' },
            { id: 'CONTRACT', name: 'Contrato' },
            { id: 'VERIFICATION_PHONE', name: 'Verificação Telefone' },
            { id: 'VERIFICATION_DOCUMENT', name: 'Verificação Documento' },
            { id: 'VERIFICATION_SELFIE', name: 'Verificação Selfie' },
            { id: 'WAITING_FOR_APPROVAL', name: 'Esperando Aprovação' },
            { id: 'ABANDONED', name: 'Abandonado' },
            { id: 'REJECTED', name: 'Rejeitado' },
            { id: 'APPROVED', name: 'Aprovado - Pagamentos Pendentes' },
            { id: 'CANCELED', name: 'Cancelado' },
            { id: 'FINISHED', name: 'Finalizado' },
            {
              id: 'REJECTED_PURCHASE_OVER_LIMIT',
              name: 'Compra fora do limite'
            },
            { id: 'REJECTED_SPC_RESTRICTION', name: 'Restrição no SPC' }
          ],"select3":_vm.sellers},on:{"onselect":_vm.selecionouOpcao,"onselect2":_vm.selecionouOpcao2,"onselect3":_vm.selecionouOpcao3}},[_c('follow-up-list-component',{attrs:{"refreshList":_vm.refreshList,"orderList":_vm.orderList,"stepList":_vm.stepList,"seller":_vm.seller,"showCollapse":true}})],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-583c0374","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/customerservice/CustomerServiceHomeNew.vue
// module id = null
// module chunks = 